import { Box, Button, Checkbox, Flex, Heading, Icon, Table, Thead, Tr, Th, Td, Tbody, Text, Divider, Switch, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { RiAddLine, RiPencilLine } from "react-icons/ri";
import apiAdonis from '../../Services/adonis';
import { Dialog, InputGroup, MenuItem } from '@blueprintjs/core';
import { MultiSelect } from '@blueprintjs/select';
import UserRows from './components';
import Email from '../../Themes/TextFormat/Email';

interface User {
    id?: number,
    username: string,
    email: string,
    status_user: boolean,
    password?: string,
    permissoes?: Array<Permissao>
}
interface Permissao {
    emp: {
        cd_emp: number,
        name: string
    },
    cc: {
        cd_cc: number,
        name: string
    }
}

export default function UserList() {
    const toast = useToast();
    const sign_in = typeof window !== 'undefined' && JSON.parse(localStorage.getItem("user") as any);
    const [users, setUsers] = useState<any>();
    const [userDialog, setUserDialog] = useState<User>();
    const [loading, setLoading] = useState<boolean>(false);
    const PickerMultiSelectPermissao = MultiSelect.ofType<Permissao>();
    const [getPermissoes, setPermissoes] = useState<Array<Permissao>>([]);
    const [getExibirPermissoes, setExibirPermissoes] = useState<boolean>(false);
    const [getNovaPermissao, setNovaPermissao] = useState<Permissao>({} as Permissao);
    const [cd_emp, setCdEmp] = useState<number>();

    useEffect(() => {
        async function componentDidMount() {
            await getEmpTipo();
        }
        componentDidMount();
    }, [])
    
    useEffect(() => {
        async function componentDidMount() {
            await apiAdonis.get(`/usuarios?cd_emp=${cd_emp}`).then((result:any) => setUsers(result.data))
            await apiAdonis.get(`/biCc?cd_emp=${cd_emp}`).then((result:any) => setPermissoes(result.data))
        }
        cd_emp && componentDidMount();
    }, [cd_emp])
    /* #region  Funções  */
    /* Sobre esta função *//**
     * Valida os dados digitados e tenta efetuar o login do usuário
     **/
    async function EfetuarCadastro(form: User): Promise<void> {
        try {
            if (await ValidarFormulario(form) && await ValidarSenha(form.password as any)) {
                setLoading(true);
                await apiAdonis.post('usuarios', {
                    username: form.username,
                    email: form.email,
                    password: form.password,
                    cd_emp: sign_in?.user.cd_emp
                }).then(async (result: any) => {
                    if(result.data.registered) {
                        form.id = result.data.usuario.id;
                        handleSetUsers(form, "push");
                        setUserDialog(undefined);
                        Notification("Sucesso!", "Usuário cadastrado.", "success", 3000);
                    }
                    else {
                        Notification("Usuário já cadastrado!", "O email registrado já possui cadastro.", "error", 1500)
                    }
                })
                setLoading(false);
            }
        }
        catch (e) {
            console.log(e)
        }
    };
    async function ValidarFormulario(form: User): Promise<Boolean> {
        if (!(form.username.length > 0)) {
            Notification("Nome não preenchido", "Informe o nome", "error", 1500)
            // NotificacaoInterna.ExibirNotificacao("Nome não preenchido", "Informe o nome", NotificacaoInterna.TipoDeNotificacao.Erro);
            console.log("Nome não preenchido")
            return false;
        }
        if (!(form.email.length > 0)) {
            Notification("Email não preenchido", "Informe o email", "error", 1500)
            // NotificacaoInterna.ExibirNotificacao("Email não preenchido", "Informe o email", NotificacaoInterna.TipoDeNotificacao.Erro);
            console.log("Email não preenchido")
            return false;
        }
        if (!Email.TextoValido(form.email)) {
            Notification("Email inválido", "Digite um email válido", "error", 1500)
            // NotificacaoInterna.ExibirNotificacao("Email inválido", "Digite um email válido", NotificacaoInterna.TipoDeNotificacao.Erro);
            console.log("Email inválido")
            return false;
        }
        if (!((form.password as any).length > 0)) {
            Notification("Senha não preenchida", "Informe a senha", "error", 1500)
            // NotificacaoInterna.ExibirNotificacao("Senha não preenchida", "Informe a senha", NotificacaoInterna.TipoDeNotificacao.Erro);
            console.log("Senha não preenchida")
            return false;
        }
        return true
    };
    async function ValidarSenha(password: string): Promise<any> {
        var letrasMaiusculas = /[A-Z]/;
        var letrasMinusculas = /[a-z]/;
        var numeros = /[0-9]/;
        var caracteresEspeciais = /[!|@|#|$|%|^|&|*|(|)|-|_]/;

        if (password.length < 6) {
            // NotificacaoInterna.ExibirNotificacao("Senha curta demais.", "Sua senha deve ter no mínimo 6 caracteres.", NotificacaoInterna.TipoDeNotificacao.Alerta)
            console.log("")
            return false;
        }

        var auxMaiuscula = 0;
        var auxMinuscula = 0;
        var auxNumero = 0;
        var auxEspecial = 0;

        for (var i = 0; i < password.length; i++) {
            if (letrasMaiusculas.test(password[i]))
                auxMaiuscula++;
            else if (letrasMinusculas.test(password[i]))
                auxMinuscula++;
            else if (numeros.test(password[i]))
                auxNumero++;
            else if (caracteresEspeciais.test(password[i]))
                auxEspecial++;
        }

        if (auxMaiuscula > 0) {
            if (auxMinuscula > 0) {
                if (auxNumero > 0) {
                    if (auxEspecial) {
                        return true;
                    }
                }
            }
        }

        if (auxMaiuscula == 0) {
            Notification("Sua senha não contém letras maiúsculas.", "Por favor, insira pelo menos uma letra maiúscula.", "error", 1500)
            // NotificacaoInterna.ExibirNotificacao("Sua senha não contém letras maiúsculas.", "Por favor, insira pelo menos uma letra maiúscula.", NotificacaoInterna.TipoDeNotificacao.Alerta)
            return;
        }
        if (auxMinuscula == 0) {
            Notification("Sua senha não contém letras minúsculas.", "Por favor, insira pelo menos uma letra minúscula.", "error", 1500)
            // NotificacaoInterna.ExibirNotificacao("Sua senha não contém letras minúsculas.", "Por favor, insira pelo menos uma letra minúscula.", NotificacaoInterna.TipoDeNotificacao.Alerta)
            return;
        }
        if (auxNumero == 0) {
            Notification("Sua senha não contém números.", "Por favor, insira pelo menos um número.", "error", 1500)
            // NotificacaoInterna.ExibirNotificacao("Sua senha não contém números.", "Por favor, insira pelo menos um número.", NotificacaoInterna.TipoDeNotificacao.Alerta)
            return;
        }
        if (auxEspecial == 0) {
            Notification("Sua senha não contém caracteres especiais.", "Por favor, insira pelo menos um caracter especial.", "error", 1500)
            // NotificacaoInterna.ExibirNotificacao("Sua senha não contém caracteres especiais.", "Por favor, insira pelo menos um caracter especial.", NotificacaoInterna.TipoDeNotificacao.Alerta)
            return;
        }
    };
    function Notification(title: string, description: string, status: "success" | "info" | "warning" | "error", duration: number) {
        toast({
            title: title,
            description: description,
            status: status,
            duration: duration,
            isClosable: true,
            position: "top"
        })
    };
    function handleSetUsers(newUser: User, type: "push" | "update") {
        let newUsers = [...users];
        switch(type) {
            case "push":
                newUsers.unshift(newUser);
                break;
            case "update":
                newUsers.map(item => {
                    if (item.id === newUser.id) {
                        item.permissoes = newUser.permissoes;
                    }
                });
                break;
        }
        setUsers(newUsers);
    };
    async function getEmpTipo() {
        await apiAdonis.get("/empPerms", {
          params: { userId: JSON.parse(localStorage.getItem("user") ?? "{}").id }
        }).then(res => {
          const emp_permissions: { cd_emp: number }[] | [] = res.data;
          if (emp_permissions.length > 1) {
            const options: any = [];
            let prompt_text;
    
            let i = ""
            emp_permissions.forEach(emp => {
              const emp_name = emp.cd_emp === 1 ? "Rio" :
                emp.cd_emp === 2 ? "Gav" :
                  emp.cd_emp === 3 ? "Omie" :
                    emp.cd_emp === 4 ? "BP8" :
                      emp.cd_emp === 20 ? "Espaco" :
                        emp.cd_emp === 25 ? "CasaETerra" : null;
              i += `${emp.cd_emp} - ${emp_name}\n`
              options.push({ cd_emp: emp.cd_emp, emp_name: emp_name })
            })
            prompt_text = i;
    
            let choose = prompt(prompt_text);
            while (!options.find((option: any) => option.cd_emp === Number(choose))) {
              choose = prompt(prompt_text);
            }
            setCdEmp(options.find((option: any) => option.cd_emp === Number(choose)).cd_emp);
          }
          else {
            setCdEmp(emp_permissions[0].cd_emp)
          }
        })
    
        return
      }
    return (
        <Box w="100%">

            <Flex bg="#f0f0f0" borderRadius="5px" w="100%" my="100px" maxWidth={1480} mx="auto" px="6">

                <Box flex="1" borderRadius={8} bg="gray.100" p={8}>
                    <Flex mb="8" justify="space-between" align="center">
                        <Heading size="md" fontWeight="normal">Usuários</Heading>
                        <div></div>
                        {/* <Button
                            as="a"
                            size="sm"
                            fontSize="sm"
                            colorScheme="blue"
                            leftIcon={<Icon as={RiAddLine} />}
                            onClick={() => {
                                const defaultUser: User = {
                                    username: "",
                                    email: "",
                                    status_user: false,
                                    password: "",
                                    permissoes: []
                                };
                                setUserDialog(defaultUser);
                            }}
                        >
                            Criar novo
                        </Button> */}

                    </Flex>
                    <Divider my="6" borderColor="gray.400" />
                    <Table>
                        <Thead>
                            <Tr>
                                <Th px="6" color="blue.500" width="8">
                                    {/* <Icon as={RiAddLine} /> */}
                                </Th>
                                <Th width="25%" >Usuário</Th>
                                {/* <Th display="flex" justifyContent="center">Ativo</Th> */}
                                <Th width="8">Permissão</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {false &&
                                <Tr>
                                    <Td px="6">
                                        <Checkbox colorScheme="blue" borderColor="blue.900" />
                                    </Td>
                                    <Td>
                                        <Box>
                                            <Text fontWeight="bold">Izacc Muzy</Text>
                                            <Text fontSize="sm" color="blue.600">muzydocerrado@gmail.com</Text>
                                        </Box>

                                    </Td>
                                    <Td>
                                        <Text fontSize="sm" color="blue.800">30 de Fevereiro, 2021</Text>
                                    </Td>
                                    <Td>
                                        <Button
                                            as="a"
                                            size="xs"
                                            fontSize="small"
                                            colorScheme="orange"
                                            leftIcon={<Icon as={RiPencilLine} />}
                                        >
                                            Editar</Button>
                                    </Td>
                                </Tr>}
                            {users && users.map((user: any) => <UserRows user={user} handleSetUsers={handleSetUsers} getPermissoes={getPermissoes} />)}
                        </Tbody>
                    </Table>
                </Box>

            </Flex>
            {userDialog && <Dialog onClose={() => setUserDialog(undefined)} isOpen={userDialog !== undefined}>
                <div style={{ width: "100%", height:"400px", margin: "0 auto", padding: "30px 30px", display:"flex", flexDirection:"column", justifyContent:"space-between" }}>
                    {/* TITLE */}
                    <Text color="gray.600" fontSize="20px" marginBottom="0px">Novo usuário</Text>
                    {/* NOME */}
                    <Flex color="gray.600" flexDirection="column" >
                        <span>Nome</span>
                        <InputGroup style={{ boxShadow: "none", marginTop: "10px", height:"40px" }} placeholder={"Nome"} value={userDialog.username}
                            onChange={(event: React.FormEvent<HTMLInputElement>) => {
                                let newUserDialog = { ...userDialog };
                                newUserDialog.username = event.currentTarget.value;
                                setUserDialog(newUserDialog);
                            }}>
                        </InputGroup>
                    </Flex>
                    {/* EMAIL */}
                    <Flex color="gray.600" flexDirection="column" >
                        <span>Email</span>
                        <InputGroup style={{ boxShadow: "none", marginTop: "10px", height:"40px" }} placeholder={"Email"} value={userDialog.email}
                            onChange={(event: React.FormEvent<HTMLInputElement>) => {
                                let newUserDialog = { ...userDialog };
                                newUserDialog.email = event.currentTarget.value;
                                setUserDialog(newUserDialog);
                            }}>
                        </InputGroup>
                    </Flex>
                    <Flex color="gray.600" flexDirection="column" >
                        <span>Senha</span>
                        <InputGroup style={{ boxShadow: "none", marginTop: "10px", height:"40px" }} placeholder={"Senha"} value={userDialog.password}
                            onChange={(event: React.FormEvent<HTMLInputElement>) => {
                                let newUserDialog = { ...userDialog };
                                newUserDialog.password = event.currentTarget.value;
                                setUserDialog(newUserDialog);
                            }}>
                        </InputGroup>
                    </Flex>
                    <Button disabled={loading} onClick={async () => await EfetuarCadastro(userDialog)} bgColor="blue.400" color="white" letterSpacing="2px">Salvar</Button>
                </div>
            </Dialog>}
        </Box>
    )
}